import './navigation.js';
import './skip-link-focus-fix.js'

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

(( $ ) => {


	$(document).ready( () => {

		// Valikko
		$('<div class="submenu-toggle"><i aria-hidden="true" class="fas fa-caret-down"></i></div>').insertBefore( ".main-navigation .sub-menu");
		$(".submenu-toggle").click(function(){
		  $(this).siblings(".sub-menu").slideToggle(200);
		});


		// Karuselli
		var mySwiper = new Swiper('.hero-carousel', {
		  // Optional parameters
			loop: true,
	    speed: 800,
	    autoplay: {
	      delay: 6000,
	      disableOnInteraction: true,
	    },

		  // If we need pagination
		  pagination: {
		    el: '.hero-carousel-pagination',
				clickable: true,
		  },

		  // Navigation arrows
		  navigation: {
		    nextEl: '.hero-carousel-next',
		    prevEl: '.hero-carousel-prev',
		  },
		})

	});


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js